/**
 * Copyright (c) HashiCorp, Inc.
 * SPDX-License-Identifier: BUSL-1.1
 */

/* tslint:disable */
/* eslint-disable */
/**
 * HashiCorp Cloud Platform Vault Reporting
 * API for Vault Reporting
 *
 * The version of the OpenAPI document: 2025-05-05
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime.ts';
import type {
  RpcStatus,
  VaultReporting20250505FetchSecretsInventoryCountResponse,
  VaultReporting20250505FetchSecretsInventoryResponse,
} from '../models/index.ts';
import {
    RpcStatusFromJSON,
    RpcStatusToJSON,
    VaultReporting20250505FetchSecretsInventoryCountResponseFromJSON,
    VaultReporting20250505FetchSecretsInventoryCountResponseToJSON,
    VaultReporting20250505FetchSecretsInventoryResponseFromJSON,
    VaultReporting20250505FetchSecretsInventoryResponseToJSON,
} from '../models/index.ts';

export interface VaultReportingServiceApiFetchSecretsInventoryRequest {
    organizationId: string;
    projectId: string;
    clusterId: string;
    filterSecretName?: string;
    filterSecretTypes?: Array<string>;
    filterNamespace?: string;
    filterMountPath?: string;
    filterPluginName?: string;
    filterPluginType?: string;
    filterConfigLastModifiedAtOperator?: FetchSecretsInventoryFilterConfigLastModifiedAtOperatorEnum;
    filterConfigLastModifiedAtAbsolute?: Date;
    filterConfigLastModifiedAtRelativeToNow?: string;
    filterConfigLastAccessedAtOperator?: FetchSecretsInventoryFilterConfigLastAccessedAtOperatorEnum;
    filterConfigLastAccessedAtAbsolute?: Date;
    filterConfigLastAccessedAtRelativeToNow?: string;
    filterSecretLastModifiedAtOperator?: FetchSecretsInventoryFilterSecretLastModifiedAtOperatorEnum;
    filterSecretLastModifiedAtAbsolute?: Date;
    filterSecretLastModifiedAtRelativeToNow?: string;
    filterSecretLastAccessedAtOperator?: FetchSecretsInventoryFilterSecretLastAccessedAtOperatorEnum;
    filterSecretLastAccessedAtAbsolute?: Date;
    filterSecretLastAccessedAtRelativeToNow?: string;
    filterNextRotationAtOperator?: FetchSecretsInventoryFilterNextRotationAtOperatorEnum;
    filterNextRotationAtAbsolute?: Date;
    filterNextRotationAtRelativeToNow?: string;
    paginationPageSize?: number;
    paginationNextPageToken?: string;
    paginationPreviousPageToken?: string;
    sortingOrderBy?: Array<string>;
}

export interface VaultReportingServiceApiFetchSecretsInventoryCountRequest {
    organizationId: string;
    projectId: string;
    clusterId: string;
    filterSecretName?: string;
    filterSecretTypes?: Array<string>;
    filterNamespace?: string;
    filterMountPath?: string;
    filterPluginName?: string;
    filterPluginType?: string;
    filterConfigLastModifiedAtOperator?: FetchSecretsInventoryCountFilterConfigLastModifiedAtOperatorEnum;
    filterConfigLastModifiedAtAbsolute?: Date;
    filterConfigLastModifiedAtRelativeToNow?: string;
    filterConfigLastAccessedAtOperator?: FetchSecretsInventoryCountFilterConfigLastAccessedAtOperatorEnum;
    filterConfigLastAccessedAtAbsolute?: Date;
    filterConfigLastAccessedAtRelativeToNow?: string;
    filterSecretLastModifiedAtOperator?: FetchSecretsInventoryCountFilterSecretLastModifiedAtOperatorEnum;
    filterSecretLastModifiedAtAbsolute?: Date;
    filterSecretLastModifiedAtRelativeToNow?: string;
    filterSecretLastAccessedAtOperator?: FetchSecretsInventoryCountFilterSecretLastAccessedAtOperatorEnum;
    filterSecretLastAccessedAtAbsolute?: Date;
    filterSecretLastAccessedAtRelativeToNow?: string;
    filterNextRotationAtOperator?: FetchSecretsInventoryCountFilterNextRotationAtOperatorEnum;
    filterNextRotationAtAbsolute?: Date;
    filterNextRotationAtRelativeToNow?: string;
}

/**
 * 
 */
export class VaultReportingServiceApi extends runtime.BaseAPI {

    /**
     */
    async fetchSecretsInventoryRaw(requestParameters: VaultReportingServiceApiFetchSecretsInventoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VaultReporting20250505FetchSecretsInventoryResponse>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling fetchSecretsInventory().'
            );
        }

        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling fetchSecretsInventory().'
            );
        }

        if (requestParameters['clusterId'] == null) {
            throw new runtime.RequiredError(
                'clusterId',
                'Required parameter "clusterId" was null or undefined when calling fetchSecretsInventory().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filterSecretName'] != null) {
            queryParameters['filter.secret_name'] = requestParameters['filterSecretName'];
        }

        if (requestParameters['filterSecretTypes'] != null) {
            queryParameters['filter.secret_types'] = requestParameters['filterSecretTypes'];
        }

        if (requestParameters['filterNamespace'] != null) {
            queryParameters['filter.namespace'] = requestParameters['filterNamespace'];
        }

        if (requestParameters['filterMountPath'] != null) {
            queryParameters['filter.mount_path'] = requestParameters['filterMountPath'];
        }

        if (requestParameters['filterPluginName'] != null) {
            queryParameters['filter.plugin_name'] = requestParameters['filterPluginName'];
        }

        if (requestParameters['filterPluginType'] != null) {
            queryParameters['filter.plugin_type'] = requestParameters['filterPluginType'];
        }

        if (requestParameters['filterConfigLastModifiedAtOperator'] != null) {
            queryParameters['filter.config_last_modified_at.operator'] = requestParameters['filterConfigLastModifiedAtOperator'];
        }

        if (requestParameters['filterConfigLastModifiedAtAbsolute'] != null) {
            queryParameters['filter.config_last_modified_at.absolute'] = (requestParameters['filterConfigLastModifiedAtAbsolute'] as any).toISOString();
        }

        if (requestParameters['filterConfigLastModifiedAtRelativeToNow'] != null) {
            queryParameters['filter.config_last_modified_at.relative_to_now'] = requestParameters['filterConfigLastModifiedAtRelativeToNow'];
        }

        if (requestParameters['filterConfigLastAccessedAtOperator'] != null) {
            queryParameters['filter.config_last_accessed_at.operator'] = requestParameters['filterConfigLastAccessedAtOperator'];
        }

        if (requestParameters['filterConfigLastAccessedAtAbsolute'] != null) {
            queryParameters['filter.config_last_accessed_at.absolute'] = (requestParameters['filterConfigLastAccessedAtAbsolute'] as any).toISOString();
        }

        if (requestParameters['filterConfigLastAccessedAtRelativeToNow'] != null) {
            queryParameters['filter.config_last_accessed_at.relative_to_now'] = requestParameters['filterConfigLastAccessedAtRelativeToNow'];
        }

        if (requestParameters['filterSecretLastModifiedAtOperator'] != null) {
            queryParameters['filter.secret_last_modified_at.operator'] = requestParameters['filterSecretLastModifiedAtOperator'];
        }

        if (requestParameters['filterSecretLastModifiedAtAbsolute'] != null) {
            queryParameters['filter.secret_last_modified_at.absolute'] = (requestParameters['filterSecretLastModifiedAtAbsolute'] as any).toISOString();
        }

        if (requestParameters['filterSecretLastModifiedAtRelativeToNow'] != null) {
            queryParameters['filter.secret_last_modified_at.relative_to_now'] = requestParameters['filterSecretLastModifiedAtRelativeToNow'];
        }

        if (requestParameters['filterSecretLastAccessedAtOperator'] != null) {
            queryParameters['filter.secret_last_accessed_at.operator'] = requestParameters['filterSecretLastAccessedAtOperator'];
        }

        if (requestParameters['filterSecretLastAccessedAtAbsolute'] != null) {
            queryParameters['filter.secret_last_accessed_at.absolute'] = (requestParameters['filterSecretLastAccessedAtAbsolute'] as any).toISOString();
        }

        if (requestParameters['filterSecretLastAccessedAtRelativeToNow'] != null) {
            queryParameters['filter.secret_last_accessed_at.relative_to_now'] = requestParameters['filterSecretLastAccessedAtRelativeToNow'];
        }

        if (requestParameters['filterNextRotationAtOperator'] != null) {
            queryParameters['filter.next_rotation_at.operator'] = requestParameters['filterNextRotationAtOperator'];
        }

        if (requestParameters['filterNextRotationAtAbsolute'] != null) {
            queryParameters['filter.next_rotation_at.absolute'] = (requestParameters['filterNextRotationAtAbsolute'] as any).toISOString();
        }

        if (requestParameters['filterNextRotationAtRelativeToNow'] != null) {
            queryParameters['filter.next_rotation_at.relative_to_now'] = requestParameters['filterNextRotationAtRelativeToNow'];
        }

        if (requestParameters['paginationPageSize'] != null) {
            queryParameters['pagination.page_size'] = requestParameters['paginationPageSize'];
        }

        if (requestParameters['paginationNextPageToken'] != null) {
            queryParameters['pagination.next_page_token'] = requestParameters['paginationNextPageToken'];
        }

        if (requestParameters['paginationPreviousPageToken'] != null) {
            queryParameters['pagination.previous_page_token'] = requestParameters['paginationPreviousPageToken'];
        }

        if (requestParameters['sortingOrderBy'] != null) {
            queryParameters['sorting.order_by'] = requestParameters['sortingOrderBy'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer authentication
        }

        const response = await this.request({
            path: `/vault-reporting/2025-05-05/organizations/{organization_id}/projects/{project_id}/clusters/{cluster_id}/reports/secrets-inventory`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters['organizationId']))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters['projectId']))).replace(`{${"cluster_id"}}`, encodeURIComponent(String(requestParameters['clusterId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VaultReporting20250505FetchSecretsInventoryResponseFromJSON(jsonValue));
    }

    /**
     */
    async fetchSecretsInventory(requestParameters: VaultReportingServiceApiFetchSecretsInventoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VaultReporting20250505FetchSecretsInventoryResponse> {
        const response = await this.fetchSecretsInventoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async fetchSecretsInventoryCountRaw(requestParameters: VaultReportingServiceApiFetchSecretsInventoryCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VaultReporting20250505FetchSecretsInventoryCountResponse>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling fetchSecretsInventoryCount().'
            );
        }

        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling fetchSecretsInventoryCount().'
            );
        }

        if (requestParameters['clusterId'] == null) {
            throw new runtime.RequiredError(
                'clusterId',
                'Required parameter "clusterId" was null or undefined when calling fetchSecretsInventoryCount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filterSecretName'] != null) {
            queryParameters['filter.secret_name'] = requestParameters['filterSecretName'];
        }

        if (requestParameters['filterSecretTypes'] != null) {
            queryParameters['filter.secret_types'] = requestParameters['filterSecretTypes'];
        }

        if (requestParameters['filterNamespace'] != null) {
            queryParameters['filter.namespace'] = requestParameters['filterNamespace'];
        }

        if (requestParameters['filterMountPath'] != null) {
            queryParameters['filter.mount_path'] = requestParameters['filterMountPath'];
        }

        if (requestParameters['filterPluginName'] != null) {
            queryParameters['filter.plugin_name'] = requestParameters['filterPluginName'];
        }

        if (requestParameters['filterPluginType'] != null) {
            queryParameters['filter.plugin_type'] = requestParameters['filterPluginType'];
        }

        if (requestParameters['filterConfigLastModifiedAtOperator'] != null) {
            queryParameters['filter.config_last_modified_at.operator'] = requestParameters['filterConfigLastModifiedAtOperator'];
        }

        if (requestParameters['filterConfigLastModifiedAtAbsolute'] != null) {
            queryParameters['filter.config_last_modified_at.absolute'] = (requestParameters['filterConfigLastModifiedAtAbsolute'] as any).toISOString();
        }

        if (requestParameters['filterConfigLastModifiedAtRelativeToNow'] != null) {
            queryParameters['filter.config_last_modified_at.relative_to_now'] = requestParameters['filterConfigLastModifiedAtRelativeToNow'];
        }

        if (requestParameters['filterConfigLastAccessedAtOperator'] != null) {
            queryParameters['filter.config_last_accessed_at.operator'] = requestParameters['filterConfigLastAccessedAtOperator'];
        }

        if (requestParameters['filterConfigLastAccessedAtAbsolute'] != null) {
            queryParameters['filter.config_last_accessed_at.absolute'] = (requestParameters['filterConfigLastAccessedAtAbsolute'] as any).toISOString();
        }

        if (requestParameters['filterConfigLastAccessedAtRelativeToNow'] != null) {
            queryParameters['filter.config_last_accessed_at.relative_to_now'] = requestParameters['filterConfigLastAccessedAtRelativeToNow'];
        }

        if (requestParameters['filterSecretLastModifiedAtOperator'] != null) {
            queryParameters['filter.secret_last_modified_at.operator'] = requestParameters['filterSecretLastModifiedAtOperator'];
        }

        if (requestParameters['filterSecretLastModifiedAtAbsolute'] != null) {
            queryParameters['filter.secret_last_modified_at.absolute'] = (requestParameters['filterSecretLastModifiedAtAbsolute'] as any).toISOString();
        }

        if (requestParameters['filterSecretLastModifiedAtRelativeToNow'] != null) {
            queryParameters['filter.secret_last_modified_at.relative_to_now'] = requestParameters['filterSecretLastModifiedAtRelativeToNow'];
        }

        if (requestParameters['filterSecretLastAccessedAtOperator'] != null) {
            queryParameters['filter.secret_last_accessed_at.operator'] = requestParameters['filterSecretLastAccessedAtOperator'];
        }

        if (requestParameters['filterSecretLastAccessedAtAbsolute'] != null) {
            queryParameters['filter.secret_last_accessed_at.absolute'] = (requestParameters['filterSecretLastAccessedAtAbsolute'] as any).toISOString();
        }

        if (requestParameters['filterSecretLastAccessedAtRelativeToNow'] != null) {
            queryParameters['filter.secret_last_accessed_at.relative_to_now'] = requestParameters['filterSecretLastAccessedAtRelativeToNow'];
        }

        if (requestParameters['filterNextRotationAtOperator'] != null) {
            queryParameters['filter.next_rotation_at.operator'] = requestParameters['filterNextRotationAtOperator'];
        }

        if (requestParameters['filterNextRotationAtAbsolute'] != null) {
            queryParameters['filter.next_rotation_at.absolute'] = (requestParameters['filterNextRotationAtAbsolute'] as any).toISOString();
        }

        if (requestParameters['filterNextRotationAtRelativeToNow'] != null) {
            queryParameters['filter.next_rotation_at.relative_to_now'] = requestParameters['filterNextRotationAtRelativeToNow'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer authentication
        }

        const response = await this.request({
            path: `/vault-reporting/2025-05-05/organizations/{organization_id}/projects/{project_id}/clusters/{cluster_id}/reports/secrets-inventory/metadata`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters['organizationId']))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters['projectId']))).replace(`{${"cluster_id"}}`, encodeURIComponent(String(requestParameters['clusterId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VaultReporting20250505FetchSecretsInventoryCountResponseFromJSON(jsonValue));
    }

    /**
     */
    async fetchSecretsInventoryCount(requestParameters: VaultReportingServiceApiFetchSecretsInventoryCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VaultReporting20250505FetchSecretsInventoryCountResponse> {
        const response = await this.fetchSecretsInventoryCountRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
  * @export
  * @enum {string}
  */
export enum FetchSecretsInventoryFilterConfigLastModifiedAtOperatorEnum {
    UNSPECIFIED = 'UNSPECIFIED',
    LESS_THAN = 'LESS_THAN',
    LESS_THAN_OR_EQUAL = 'LESS_THAN_OR_EQUAL',
    GREATER_THAN = 'GREATER_THAN',
    GREATER_THAN_OR_EQUAL = 'GREATER_THAN_OR_EQUAL'
}
/**
  * @export
  * @enum {string}
  */
export enum FetchSecretsInventoryFilterConfigLastAccessedAtOperatorEnum {
    UNSPECIFIED = 'UNSPECIFIED',
    LESS_THAN = 'LESS_THAN',
    LESS_THAN_OR_EQUAL = 'LESS_THAN_OR_EQUAL',
    GREATER_THAN = 'GREATER_THAN',
    GREATER_THAN_OR_EQUAL = 'GREATER_THAN_OR_EQUAL'
}
/**
  * @export
  * @enum {string}
  */
export enum FetchSecretsInventoryFilterSecretLastModifiedAtOperatorEnum {
    UNSPECIFIED = 'UNSPECIFIED',
    LESS_THAN = 'LESS_THAN',
    LESS_THAN_OR_EQUAL = 'LESS_THAN_OR_EQUAL',
    GREATER_THAN = 'GREATER_THAN',
    GREATER_THAN_OR_EQUAL = 'GREATER_THAN_OR_EQUAL'
}
/**
  * @export
  * @enum {string}
  */
export enum FetchSecretsInventoryFilterSecretLastAccessedAtOperatorEnum {
    UNSPECIFIED = 'UNSPECIFIED',
    LESS_THAN = 'LESS_THAN',
    LESS_THAN_OR_EQUAL = 'LESS_THAN_OR_EQUAL',
    GREATER_THAN = 'GREATER_THAN',
    GREATER_THAN_OR_EQUAL = 'GREATER_THAN_OR_EQUAL'
}
/**
  * @export
  * @enum {string}
  */
export enum FetchSecretsInventoryFilterNextRotationAtOperatorEnum {
    UNSPECIFIED = 'UNSPECIFIED',
    LESS_THAN = 'LESS_THAN',
    LESS_THAN_OR_EQUAL = 'LESS_THAN_OR_EQUAL',
    GREATER_THAN = 'GREATER_THAN',
    GREATER_THAN_OR_EQUAL = 'GREATER_THAN_OR_EQUAL'
}
/**
  * @export
  * @enum {string}
  */
export enum FetchSecretsInventoryCountFilterConfigLastModifiedAtOperatorEnum {
    UNSPECIFIED = 'UNSPECIFIED',
    LESS_THAN = 'LESS_THAN',
    LESS_THAN_OR_EQUAL = 'LESS_THAN_OR_EQUAL',
    GREATER_THAN = 'GREATER_THAN',
    GREATER_THAN_OR_EQUAL = 'GREATER_THAN_OR_EQUAL'
}
/**
  * @export
  * @enum {string}
  */
export enum FetchSecretsInventoryCountFilterConfigLastAccessedAtOperatorEnum {
    UNSPECIFIED = 'UNSPECIFIED',
    LESS_THAN = 'LESS_THAN',
    LESS_THAN_OR_EQUAL = 'LESS_THAN_OR_EQUAL',
    GREATER_THAN = 'GREATER_THAN',
    GREATER_THAN_OR_EQUAL = 'GREATER_THAN_OR_EQUAL'
}
/**
  * @export
  * @enum {string}
  */
export enum FetchSecretsInventoryCountFilterSecretLastModifiedAtOperatorEnum {
    UNSPECIFIED = 'UNSPECIFIED',
    LESS_THAN = 'LESS_THAN',
    LESS_THAN_OR_EQUAL = 'LESS_THAN_OR_EQUAL',
    GREATER_THAN = 'GREATER_THAN',
    GREATER_THAN_OR_EQUAL = 'GREATER_THAN_OR_EQUAL'
}
/**
  * @export
  * @enum {string}
  */
export enum FetchSecretsInventoryCountFilterSecretLastAccessedAtOperatorEnum {
    UNSPECIFIED = 'UNSPECIFIED',
    LESS_THAN = 'LESS_THAN',
    LESS_THAN_OR_EQUAL = 'LESS_THAN_OR_EQUAL',
    GREATER_THAN = 'GREATER_THAN',
    GREATER_THAN_OR_EQUAL = 'GREATER_THAN_OR_EQUAL'
}
/**
  * @export
  * @enum {string}
  */
export enum FetchSecretsInventoryCountFilterNextRotationAtOperatorEnum {
    UNSPECIFIED = 'UNSPECIFIED',
    LESS_THAN = 'LESS_THAN',
    LESS_THAN_OR_EQUAL = 'LESS_THAN_OR_EQUAL',
    GREATER_THAN = 'GREATER_THAN',
    GREATER_THAN_OR_EQUAL = 'GREATER_THAN_OR_EQUAL'
}
